import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a1a965"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid container-dashboard" }
const _hoisted_2 = { class: "d-flex flex-row align-items-center pb-8 gap-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  height: "1em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  style: {"height":"1.4rem","width":"1.4rem"},
  class: "spinner-border m-auto",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  style: {"font-size":".9rem"},
  class: "m-0"
}
const _hoisted_11 = {
  key: 3,
  style: {"font-size":".9rem"},
  class: "m-0"
}
const _hoisted_12 = { class: "row cards_principais" }
const _hoisted_13 = { class: "col-lg-6 col-md-12 col-sm-12 mb-6" }
const _hoisted_14 = {
  key: 0,
  class: "apexAtendimentos h-100 p-3 card d-flex flex-row justify-content-between"
}
const _hoisted_15 = {
  key: 1,
  width: "220",
  height: "220",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M19.4041 11.1765H10.6802L16.4902 16.9864C16.7122 17.2085 17.0777 17.2265 17.306 17.0114C18.7288 15.671 19.7074 13.864 19.9946 11.8327C20.0438 11.4849 19.7552 11.1765 19.4041 11.1765ZM18.8221 8.79412C18.5192 4.40221 15.0096 0.892649 10.6177 0.589708C10.2824 0.566547 10.0001 0.849267 10.0001 1.1853V9.41177H18.2269C18.5629 9.41177 18.8453 9.12941 18.8221 8.79412ZM8.23537 11.1765V2.45258C8.23537 2.10147 7.92692 1.81287 7.57949 1.86213C3.19824 2.48125 -0.150655 6.30883 0.00522741 10.896C0.165522 15.607 4.22177 19.4702 8.93501 19.411C10.7879 19.3879 12.5001 18.7908 13.9078 17.7923C14.1982 17.5864 14.2174 17.1588 13.9655 16.907L8.23537 11.1765Z",
  fill: "gray"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "apexAtendimentosInfo d-flex flex-column justify-content-between p-4" }
const _hoisted_19 = { class: "headerApexAtendimentos d-flex flex-row justify-content-between col-12 gap-5" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo" }, "Atendimentos", -1))
const _hoisted_22 = { class: "d-flex flex-row gap-5 flex-wrap justify-content-center" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  style: {"height":"1.4rem","width":"1.4rem"},
  class: "spinner-border m-auto",
  role: "status"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 8 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  style: {"color":"#fefefe","height":"1.5rem","width":"1.5rem"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "d-flex flex-column align-content-center" }
const _hoisted_38 = { class: "legInfo d-flex flex-row justify-content-between" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center gap-4 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "colorLegendaAtendimento",
    style: {"background":"#3699ff"}
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "texto" }, "Busca placa")
], -1))
const _hoisted_40 = { class: "numbersLegend" }
const _hoisted_41 = { class: "legInfo d-flex flex-row justify-content-between" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center gap-4 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "colorLegendaAtendimento",
    style: {"background":"#203972"}
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "texto" }, "Busca manual")
], -1))
const _hoisted_43 = { class: "numbersLegend" }
const _hoisted_44 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_45 = { class: "col-lg-6 col-md-12 col-sm-12 mb-6" }
const _hoisted_46 = {
  key: 0,
  class: "apexOS h-100 p-3 card d-flex flex-row justify-content-lg-between justify-content-md-around justify-content-sm-around"
}
const _hoisted_47 = { class: "apexAtendimentosInfo d-flex flex-column justify-content-between p-4" }
const _hoisted_48 = { class: "headerApexAtendimentos d-flex flex-row gap-5" }
const _hoisted_49 = { class: "d-flex flex-column" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo" }, "Valor ofertado", -1))
const _hoisted_51 = {
  class: "fs-5 fw-bolder",
  style: {"color":"#1bc5bd"}
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column\" style=\"min-width:17rem;\" data-v-40a1a965><div class=\"w-100 legInfo d-flex flex-row gap-4 align-items-center\" data-v-40a1a965><span class=\"colorLegendaAtendimento\" style=\"background:#1bc5bd;\" data-v-40a1a965></span><h3 class=\"texto\" data-v-40a1a965>Finalizados</h3></div><div class=\"w-100 legInfo d-flex flex-row gap-4 align-items-center\" data-v-40a1a965><span class=\"colorLegendaAtendimento\" style=\"background:#3699ff;\" data-v-40a1a965></span><h3 class=\"texto\" data-v-40a1a965>Orçamentos</h3></div><div class=\"w-100 legInfo d-flex flex-row gap-4 align-items-center\" data-v-40a1a965><span class=\"colorLegendaAtendimento\" style=\"background:#ffb822;\" data-v-40a1a965></span><h3 class=\"texto\" data-v-40a1a965>Consultas ao manual</h3></div></div>", 1)
const _hoisted_53 = {
  key: 1,
  width: "220",
  height: "220",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M19.4041 11.1765H10.6802L16.4902 16.9864C16.7122 17.2085 17.0777 17.2265 17.306 17.0114C18.7288 15.671 19.7074 13.864 19.9946 11.8327C20.0438 11.4849 19.7552 11.1765 19.4041 11.1765ZM18.8221 8.79412C18.5192 4.40221 15.0096 0.892649 10.6177 0.589708C10.2824 0.566547 10.0001 0.849267 10.0001 1.1853V9.41177H18.2269C18.5629 9.41177 18.8453 9.12941 18.8221 8.79412ZM8.23537 11.1765V2.45258C8.23537 2.10147 7.92692 1.81287 7.57949 1.86213C3.19824 2.48125 -0.150655 6.30883 0.00522741 10.896C0.165522 15.607 4.22177 19.4702 8.93501 19.411C10.7879 19.3879 12.5001 18.7908 13.9078 17.7923C14.1982 17.5864 14.2174 17.1588 13.9655 16.907L8.23537 11.1765Z",
  fill: "gray"
}, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_57 = { class: "row legenda_icons" }
const _hoisted_58 = { class: "col-12 mb-6" }
const _hoisted_59 = {
  key: 0,
  class: "d-flex flex-row h-0 bg-white",
  style: {"border-radius":"0.475rem !important"}
}
const _hoisted_60 = {
  class: "d-flex flex-column w-100",
  style: {"border-radius":"0.475rem !important"}
}
const _hoisted_61 = { class: "d-flex flex-column" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-between align-items-center p-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitulo" }, "Pagos"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_63 = {
  class: "d-flex flex-row flex-wrap p-4 gap-2",
  style: {"border-bottom":"0.5px solid #B5B5C3","border-radius":"0.475rem"}
}
const _hoisted_64 = {
  style: {"border":"0.5px solid #B5B5C3","border-radius":"0.475rem"},
  class: "d-flex flex-row col-6"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"#f8f8f8","border-radius":"0.475rem 0px 0px 0.475rem"},
  class: "p-4 d-flex flex-column gap-2 justify-content-center align-content-center align-items-center col"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M31.75 5H25.5C25.5 2.24219 23.2578 0 20.5 0C17.7422 0 15.5 2.24219 15.5 5H9.25C7.17969 5 5.5 6.67969 5.5 8.75V36.25C5.5 38.3203 7.17969 40 9.25 40H31.75C33.8203 40 35.5 38.3203 35.5 36.25V8.75C35.5 6.67969 33.8203 5 31.75 5ZM20.5 3.125C21.5391 3.125 22.375 3.96094 22.375 5C22.375 6.03906 21.5391 6.875 20.5 6.875C19.4609 6.875 18.625 6.03906 18.625 5C18.625 3.96094 19.4609 3.125 20.5 3.125ZM29.9688 21.2344L18.7969 32.3125C18.4297 32.6797 17.8359 32.6719 17.4688 32.3047L11.0156 25.7969C10.6484 25.4297 10.6562 24.8359 11.0234 24.4688L13.2422 22.2656C13.6094 21.8984 14.2031 21.9062 14.5703 22.2734L18.1641 25.8984L26.4453 17.6797C26.8125 17.3125 27.4062 17.3203 27.7734 17.6875L29.9766 19.9062C30.3437 20.2812 30.3359 20.8672 29.9688 21.2344Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.5 3.125C21.5391 3.125 22.375 3.96094 22.375 5C22.375 6.03906 21.5391 6.875 20.5 6.875C19.461 6.875 18.625 6.03906 18.625 5C18.625 3.96094 19.461 3.125 20.5 3.125ZM29.9688 21.2344L18.7969 32.3125C18.4297 32.6797 17.836 32.6719 17.4688 32.3047L11.0157 25.7969C10.6485 25.4297 10.6563 24.8359 11.0235 24.4688L13.2422 22.2656C13.6094 21.8984 14.2032 21.9062 14.5703 22.2734L18.1641 25.8984L26.4453 17.6797C26.8125 17.3125 27.4063 17.3203 27.7735 17.6875L29.9766 19.9062C30.3438 20.2812 30.336 20.8672 29.9688 21.2344Z",
      fill: "#203972"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "O.S.")
], -1))
const _hoisted_66 = { class: "d-flex flex-column gap-2 p-4 d-flex col-10" }
const _hoisted_67 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-check" }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Atendimentos:", -1))
const _hoisted_70 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-dollar-sign" }, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor faturado:", -1))
const _hoisted_73 = {
  style: {"border":"0.5px solid #B5B5C3","border-radius":"0.475rem"},
  class: "d-flex flex-row col"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"#f8f8f8","border-radius":"0.475rem 0px 0px 0.475rem"},
  class: "p-4 d-flex flex-column gap-2 justify-content-center align-content-center align-items-center col"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30.5 12.5H25.5H15.5H10.5H3V33.75C3 37.2018 5.7982 40 9.25 40H31.75C35.2018 40 38 37.2018 38 33.75V12.5H30.5ZM26.125 17.5C26.125 18.5355 26.9645 19.375 28 19.375C29.0355 19.375 29.875 18.5355 29.875 17.5C29.875 16.4645 29.0355 15.625 28 15.625C26.9645 15.625 26.125 16.4645 26.125 17.5ZM11.125 17.5C11.125 18.5355 11.9645 19.375 13 19.375C14.0355 19.375 14.875 18.5355 14.875 17.5C14.875 16.4645 14.0355 15.625 13 15.625C11.9645 15.625 11.125 16.4645 11.125 17.5Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30.5 10V12.5H25.5V10C25.5 7.24297 23.257 5 20.5 5C17.743 5 15.5 7.24297 15.5 10V12.5H10.5V10C10.5 4.48594 14.9859 0 20.5 0C26.014 0 30.5 4.48594 30.5 10Z",
      fill: "#203972"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Bazar")
], -1))
const _hoisted_75 = { class: "d-flex flex-column gap-2 p-4 d-flex col-10" }
const _hoisted_76 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-check" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Atendimentos:", -1))
const _hoisted_79 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-dollar-sign" }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor faturado:", -1))
const _hoisted_82 = {
  class: "d-flex flex-row gap-2 align-items-center p-4",
  id: "listaDadosTransmitidos",
  style: {"background-color":"#F8F8F8","border-radius":"0px 0px 0.475rem 0.475rem"}
}
const _hoisted_83 = { class: "col d-flex align-items-center gap-2 flex-row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Atendimentos:", -1))
const _hoisted_85 = { class: "fw-bolder fs-5" }
const _hoisted_86 = {
  class: "col d-flex align-items-center gap-2 flex-row",
  style: {"min-width":"fit-content"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Consumidores preenchidos:", -1))
const _hoisted_88 = { class: "fw-bolder fs-5 pe-2" }
const _hoisted_89 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Faturamento:", -1))
const _hoisted_91 = { class: "fw-bolder fs-5" }
const _hoisted_92 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cesta de produtos:", -1))
const _hoisted_94 = { class: "fw-bolder fs-5" }
const _hoisted_95 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Ticket médio:", -1))
const _hoisted_97 = { class: "fw-bolder fs-5" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "col-md col-sm d-flex flex-row gap-2",
  style: {"height":"2.5rem"}
}, null, -1))
const _hoisted_99 = { class: "row legenda_icons" }
const _hoisted_100 = { class: "col-12 mb-6" }
const _hoisted_101 = {
  key: 0,
  class: "d-flex flex-row h-0 bg-white",
  style: {"border-radius":"0.475rem !important"}
}
const _hoisted_102 = {
  class: "d-flex flex-column w-100",
  style: {"border-radius":"0.475rem !important"}
}
const _hoisted_103 = { class: "d-flex flex-column" }
const _hoisted_104 = { class: "d-flex flex-row justify-content-between align-items-center p-4" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitulo" }, "Finalizados", -1))
const _hoisted_106 = { style: {"color":"#1bc5bd"} }
const _hoisted_107 = {
  class: "d-flex flex-row flex-wrap p-4 gap-2",
  style: {"border-bottom":"0.5px solid #B5B5C3","border-radius":"0.475rem"}
}
const _hoisted_108 = {
  style: {"border":"0.5px solid #B5B5C3","border-radius":"0.475rem"},
  class: "d-flex flex-row col-6"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"#f8f8f8","border-radius":"0.475rem 0px 0px 0.475rem"},
  class: "p-4 d-flex flex-column gap-2 justify-content-center align-content-center align-items-center col"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M31.75 5H25.5C25.5 2.24219 23.2578 0 20.5 0C17.7422 0 15.5 2.24219 15.5 5H9.25C7.17969 5 5.5 6.67969 5.5 8.75V36.25C5.5 38.3203 7.17969 40 9.25 40H31.75C33.8203 40 35.5 38.3203 35.5 36.25V8.75C35.5 6.67969 33.8203 5 31.75 5ZM20.5 3.125C21.5391 3.125 22.375 3.96094 22.375 5C22.375 6.03906 21.5391 6.875 20.5 6.875C19.4609 6.875 18.625 6.03906 18.625 5C18.625 3.96094 19.4609 3.125 20.5 3.125ZM29.9688 21.2344L18.7969 32.3125C18.4297 32.6797 17.8359 32.6719 17.4688 32.3047L11.0156 25.7969C10.6484 25.4297 10.6562 24.8359 11.0234 24.4688L13.2422 22.2656C13.6094 21.8984 14.2031 21.9062 14.5703 22.2734L18.1641 25.8984L26.4453 17.6797C26.8125 17.3125 27.4062 17.3203 27.7734 17.6875L29.9766 19.9062C30.3437 20.2812 30.3359 20.8672 29.9688 21.2344Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.5 3.125C21.5391 3.125 22.375 3.96094 22.375 5C22.375 6.03906 21.5391 6.875 20.5 6.875C19.461 6.875 18.625 6.03906 18.625 5C18.625 3.96094 19.461 3.125 20.5 3.125ZM29.9688 21.2344L18.7969 32.3125C18.4297 32.6797 17.836 32.6719 17.4688 32.3047L11.0157 25.7969C10.6485 25.4297 10.6563 24.8359 11.0235 24.4688L13.2422 22.2656C13.6094 21.8984 14.2032 21.9062 14.5703 22.2734L18.1641 25.8984L26.4453 17.6797C26.8125 17.3125 27.4063 17.3203 27.7735 17.6875L29.9766 19.9062C30.3438 20.2812 30.336 20.8672 29.9688 21.2344Z",
      fill: "#203972"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "O.S.")
], -1))
const _hoisted_110 = { class: "d-flex flex-column gap-2 p-4 d-flex col-10" }
const _hoisted_111 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-check" }, null, -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Atendimentos:", -1))
const _hoisted_114 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-dollar-sign" }, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor faturado:", -1))
const _hoisted_117 = {
  style: {"border":"0.5px solid #B5B5C3","border-radius":"0.475rem"},
  class: "d-flex flex-row col"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"#f8f8f8","border-radius":"0.475rem 0px 0px 0.475rem"},
  class: "p-4 d-flex flex-column gap-2 justify-content-center align-content-center align-items-center col"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30.5 12.5H25.5H15.5H10.5H3V33.75C3 37.2018 5.7982 40 9.25 40H31.75C35.2018 40 38 37.2018 38 33.75V12.5H30.5ZM26.125 17.5C26.125 18.5355 26.9645 19.375 28 19.375C29.0355 19.375 29.875 18.5355 29.875 17.5C29.875 16.4645 29.0355 15.625 28 15.625C26.9645 15.625 26.125 16.4645 26.125 17.5ZM11.125 17.5C11.125 18.5355 11.9645 19.375 13 19.375C14.0355 19.375 14.875 18.5355 14.875 17.5C14.875 16.4645 14.0355 15.625 13 15.625C11.9645 15.625 11.125 16.4645 11.125 17.5Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30.5 10V12.5H25.5V10C25.5 7.24297 23.257 5 20.5 5C17.743 5 15.5 7.24297 15.5 10V12.5H10.5V10C10.5 4.48594 14.9859 0 20.5 0C26.014 0 30.5 4.48594 30.5 10Z",
      fill: "#203972"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Bazar")
], -1))
const _hoisted_119 = { class: "d-flex flex-column gap-2 p-4 d-flex col-10" }
const _hoisted_120 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-check" }, null, -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Atendimentos:", -1))
const _hoisted_123 = { class: "d-flex flex-row align-items-center gap-3" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "col-1 text-end fas fa-dollar-sign" }, null, -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor faturado:", -1))
const _hoisted_126 = {
  class: "d-flex flex-row gap-2 align-items-center p-4",
  id: "listaDadosTransmitidos",
  style: {"background-color":"#F8F8F8","border-radius":"0px 0px 0.475rem 0.475rem"}
}
const _hoisted_127 = { class: "col d-flex align-items-center gap-2 flex-row" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Atendimentos:", -1))
const _hoisted_129 = { class: "fw-bolder fs-5" }
const _hoisted_130 = {
  class: "col d-flex align-items-center gap-2 flex-row",
  style: {"min-width":"fit-content"}
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Consumidores preenchidos:", -1))
const _hoisted_132 = { class: "fw-bolder fs-5 pe-2" }
const _hoisted_133 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Faturamento:", -1))
const _hoisted_135 = { class: "fw-bolder fs-5" }
const _hoisted_136 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cesta de produtos:", -1))
const _hoisted_138 = { class: "fw-bolder fs-5" }
const _hoisted_139 = { class: "col-md col-sm d-flex align-items-center justify-content-center gap-2 flex-row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Ticket médio:", -1))
const _hoisted_141 = { class: "fw-bolder fs-5" }
const _hoisted_142 = {
  class: "col-md col-sm d-flex flex-row gap-2",
  style: {"height":"2.5rem"}
}
const _hoisted_143 = ["disabled"]
const _hoisted_144 = {
  key: 0,
  width: "20",
  height: "15",
  viewBox: "0 0 8 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z" }, null, -1))
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = {
  key: 1,
  style: {"color":"#fefefe","height":"1.5rem","width":"1.5rem"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_149 = [
  _hoisted_148
]
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Qtds", -1))
const _hoisted_151 = ["disabled"]
const _hoisted_152 = {
  key: 0,
  width: "20",
  height: "15",
  viewBox: "0 0 8 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z" }, null, -1))
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = {
  key: 1,
  style: {"color":"#fefefe","height":"1.5rem","width":"1.5rem"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valores", -1))
const _hoisted_159 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_160 = { class: "col-lg-6 col-md-6 col-sm-12 mb-6" }
const _hoisted_161 = {
  key: 0,
  class: "card d-flex flex-row h-0",
  style: {"min-height":"10rem"}
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center p-6",
  style: {"background":"#f9f9f9","border-radius":"15px 0px 0px 15px","min-width":"117px"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "m-auto",
    width: "40",
    height: "3.125rem",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.15",
      d: "M43.5664 10.2539L34.0059 0.683594C33.5664 0.244141 32.9707 0 32.3457 0H31.75V12.5H44.25V11.9043C44.25 11.2891 44.0059 10.6934 43.5664 10.2539ZM28.625 13.2812V0H9.09375C7.79492 0 6.75 1.04492 6.75 2.34375V47.6562C6.75 48.9551 7.79492 50 9.09375 50H41.9062C43.2051 50 44.25 48.9551 44.25 47.6562V15.625H30.9688C29.6797 15.625 28.625 14.5703 28.625 13.2812ZM13 7.03125C13 6.59961 13.3496 6.25 13.7812 6.25H21.5938C22.0254 6.25 22.375 6.59961 22.375 7.03125V8.59375C22.375 9.02539 22.0254 9.375 21.5938 9.375H13.7812C13.3496 9.375 13 9.02539 13 8.59375V7.03125ZM13 14.8438V13.2812C13 12.8496 13.3496 12.5 13.7812 12.5H21.5938C22.0254 12.5 22.375 12.8496 22.375 13.2812V14.8438C22.375 15.2754 22.0254 15.625 21.5938 15.625H13.7812C13.3496 15.625 13 15.2754 13 14.8438ZM27.0625 40.6133V42.9688C27.0625 43.4004 26.7129 43.75 26.2812 43.75H24.7188C24.2871 43.75 23.9375 43.4004 23.9375 42.9688V40.5967C22.835 40.54 21.7627 40.1553 20.874 39.4883C20.4932 39.2021 20.4736 38.6318 20.8184 38.3027L21.9658 37.208C22.2363 36.9502 22.6387 36.9385 22.9551 37.1367C23.333 37.373 23.7617 37.5 24.207 37.5H26.9521C27.5869 37.5 28.1045 36.9219 28.1045 36.2119C28.1045 35.6309 27.752 35.1191 27.248 34.9688L22.8535 33.6504C21.0381 33.1055 19.7695 31.3633 19.7695 29.4131C19.7695 27.0186 21.6299 25.0732 23.9365 25.0117V22.6562C23.9365 22.2246 24.2861 21.875 24.7178 21.875H26.2803C26.7119 21.875 27.0615 22.2246 27.0615 22.6562V25.0283C28.1641 25.085 29.2363 25.4688 30.125 26.1367C30.5059 26.4229 30.5254 26.9932 30.1807 27.3223L29.0332 28.417C28.7627 28.6748 28.3604 28.6865 28.0439 28.4883C27.666 28.251 27.2373 28.125 26.792 28.125H24.0469C23.4121 28.125 22.8945 28.7031 22.8945 29.4131C22.8945 29.9941 23.2471 30.5059 23.751 30.6563L28.1455 31.9746C29.9609 32.5195 31.2295 34.2617 31.2295 36.2119C31.2295 38.6074 29.3691 40.5518 27.0625 40.6133Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M43.5664 10.2539L34.0059 0.683594C33.5664 0.244141 32.9707 0 32.3457 0H31.75V12.5H44.25V11.9043C44.25 11.2891 44.0059 10.6934 43.5664 10.2539ZM13 7.03125C13 6.59961 13.3496 6.25 13.7812 6.25H21.5938C22.0254 6.25 22.375 6.59961 22.375 7.03125V8.59375C22.375 9.02539 22.0254 9.375 21.5938 9.375H13.7812C13.3496 9.375 13 9.02539 13 8.59375V7.03125ZM13 14.8438V13.2812C13 12.8496 13.3496 12.5 13.7812 12.5H21.5938C22.0254 12.5 22.375 12.8496 22.375 13.2812V14.8438C22.375 15.2754 22.0254 15.625 21.5938 15.625H13.7812C13.3496 15.625 13 15.2754 13 14.8438ZM27.0625 40.6133V42.9688C27.0625 43.4004 26.7129 43.75 26.2812 43.75H24.7188C24.2871 43.75 23.9375 43.4004 23.9375 42.9688V40.5967C22.835 40.54 21.7627 40.1553 20.874 39.4883C20.4932 39.2021 20.4736 38.6318 20.8184 38.3027L21.9658 37.208C22.2363 36.9502 22.6387 36.9385 22.9551 37.1367C23.333 37.373 23.7617 37.5 24.207 37.5H26.9521C27.5869 37.5 28.1045 36.9219 28.1045 36.2119C28.1045 35.6309 27.752 35.1191 27.248 34.9688L22.8535 33.6504C21.0381 33.1055 19.7695 31.3633 19.7695 29.4131C19.7695 27.0186 21.6299 25.0732 23.9365 25.0117V22.6562C23.9365 22.2246 24.2861 21.875 24.7178 21.875H26.2803C26.7119 21.875 27.0615 22.2246 27.0615 22.6562V25.0283C28.1641 25.085 29.2363 25.4688 30.125 26.1367C30.5059 26.4229 30.5254 26.9932 30.1807 27.3223L29.0332 28.417C28.7627 28.6748 28.3604 28.6865 28.0439 28.4883C27.666 28.251 27.2373 28.125 26.792 28.125H24.0469C23.4121 28.125 22.8945 28.7031 22.8945 29.4131C22.8945 29.9941 23.2471 30.5059 23.751 30.6563L28.1455 31.9746C29.9609 32.5195 31.2295 34.2617 31.2295 36.2119C31.2295 38.6074 29.3691 40.5518 27.0625 40.6133Z",
      fill: "#203972"
    })
  ])
], -1))
const _hoisted_163 = { class: "d-flex flex-column w-100 ps-6 pe-6 pt-3 pb-3 justify-content-between" }
const _hoisted_164 = {
  class: "d-flex flex-row justify-content-between align-items-center mb-4 pb-3 pt-2",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitulo" }, "Orçamentos", -1))
const _hoisted_166 = {
  class: "mt-2",
  style: {"color":"#3699ff"}
}
const _hoisted_167 = { class: "d-flex flex-column gap-4" }
const _hoisted_168 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Atendimentos:", -1))
const _hoisted_170 = { class: "fw-bolder fs-5" }
const _hoisted_171 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Valor", -1))
const _hoisted_173 = { class: "fw-bolder fs-5" }
const _hoisted_174 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Ticket médio", -1))
const _hoisted_176 = { class: "fw-bolder fs-5" }
const _hoisted_177 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_178 = { class: "col-lg-6 col-md-6 col-sm-12 mb-6" }
const _hoisted_179 = {
  key: 0,
  class: "card d-flex flex-row h-100"
}
const _hoisted_180 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center p-6\" style=\"background:#f9f9f9;border-radius:15px 0px 0px 15px;min-width:117px;\" data-v-40a1a965><svg class=\"m-auto\" width=\"3.125rem\" height=\"3.125rem\" viewBox=\"0 0 51 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-40a1a965><g clip-path=\"url(#clip0_2205_1316)\" data-v-40a1a965><path opacity=\"0.3\" d=\"M49.8164 43.2324L40.0801 33.4961C39.6406 33.0566 39.0449 32.8125 38.4199 32.8125H36.8281C39.5234 29.3652 41.125 25.0293 41.125 20.3125C41.125 9.0918 32.0332 0 20.8125 0C9.5918 0 0.5 9.0918 0.5 20.3125C0.5 31.5332 9.5918 40.625 20.8125 40.625C25.5293 40.625 29.8652 39.0234 33.3125 36.3281V37.9199C33.3125 38.5449 33.5566 39.1406 33.9961 39.5801L43.7324 49.3164C44.6504 50.2344 46.1348 50.2344 47.043 49.3164L49.8066 46.5527C50.7246 45.6348 50.7246 44.1504 49.8164 43.2324ZM20.8125 32.8125C13.9082 32.8125 8.3125 27.2266 8.3125 20.3125C8.3125 13.4082 13.8984 7.8125 20.8125 7.8125C27.7168 7.8125 33.3125 13.3984 33.3125 20.3125C33.3125 27.2168 27.7266 32.8125 20.8125 32.8125Z\" fill=\"#203972\" data-v-40a1a965></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33.3125 36.3281L36.8281 32.8125C39.5234 29.3652 41.125 25.0293 41.125 20.3125C41.125 9.0918 32.0332 0 20.8125 0C9.5918 0 0.5 9.0918 0.5 20.3125C0.5 31.5332 9.5918 40.625 20.8125 40.625C25.5293 40.625 29.8652 39.0234 33.3125 36.3281ZM8.3125 20.3125C8.3125 27.2266 13.9082 32.8125 20.8125 32.8125C27.7266 32.8125 33.3125 27.2168 33.3125 20.3125C33.3125 13.3984 27.7168 7.8125 20.8125 7.8125C13.8984 7.8125 8.3125 13.4082 8.3125 20.3125Z\" fill=\"#203972\" data-v-40a1a965></path></g><defs data-v-40a1a965><clipPath id=\"clip0_2205_1316\" data-v-40a1a965><rect width=\"50px\" height=\"50px\" fill=\"white\" transform=\"translate(0.5)\" data-v-40a1a965></rect></clipPath></defs></svg></div>", 1)
const _hoisted_181 = { class: "d-flex flex-column w-100 ps-6 pe-6 pt-3 pb-3" }
const _hoisted_182 = {
  class: "d-flex flex-row justify-content-between align-items-center mb-4 pb-3 pt-2",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitulo" }, "Consultas ao manual", -1))
const _hoisted_184 = {
  class: "mt-2",
  style: {"color":"#ffb822"}
}
const _hoisted_185 = { class: "d-flex flex-column" }
const _hoisted_186 = { class: "d-flex flex-row justify-content-between mb-1" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Atendimentos:", -1))
const _hoisted_188 = { class: "fw-bolder fs-5" }
const _hoisted_189 = {
  key: 1,
  class: "card p-4 mb-5"
}
const _hoisted_190 = {
  key: 0,
  class: "col-12 mb-6 d-flex gap-6 flex-wrap"
}
const _hoisted_191 = {
  key: 0,
  style: {"position":"absolute","right":"-16px"}
}
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "9",
  height: "16",
  viewBox: "0 0 9 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.3",
    d: "M8.76129 8.61675L2.16119 15.6796C1.84287 16.0202 1.3268 16.0202 1.00852 15.6796L0.238729 14.8558C-0.0790435 14.5158 -0.0796547 13.9646 0.237371 13.6238L5.46807 7.99999L0.237371 2.37622C-0.0796547 2.03537 -0.0790435 1.48424 0.238729 1.14419L1.00852 0.320418C1.32684 -0.0202174 1.84291 -0.0202174 2.16119 0.320418L8.76126 7.38326C9.07957 7.72386 9.07957 8.27612 8.76129 8.61675Z",
    fill: "#B5B5C3"
  })
], -1))
const _hoisted_193 = [
  _hoisted_192
]
const _hoisted_194 = {
  key: 1,
  class: "card p-4 mb-5"
}
const _hoisted_195 = { class: "row ofertas_recusadas" }
const _hoisted_196 = { class: "col-12" }
const _hoisted_197 = {
  key: 0,
  class: "card d-flex flex-row mb-6"
}
const _hoisted_198 = {
  class: "d-flex align-items-center p-6",
  style: {"background":"#f9f9f9","border-radius":"15px 0px 0px 15px","min-width":"117px"}
}
const _hoisted_199 = {
  style: {"margin":"auto"},
  width: "40",
  height: "2.8125rem",
  viewBox: "0 0 51 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.5" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.2738 2.00073C23.663 3.79755 24.0743 5.86473 25.5058 7.2974L30.2083 11.9999L25.5066 16.7015C23.4973 18.7109 23.4986 21.9672 25.5058 23.976L27.023 25.4933C29.0318 27.5021 32.2895 27.5021 34.2984 25.4933L39 20.7916L43.7016 25.4933C44.9359 26.7275 46.6415 27.2034 48.2392 26.921C45.5347 35.5504 35.9327 41.9285 24.5 41.9285C20.825 41.9285 17.351 41.247 14.2215 40.0664C11.8672 41.9477 7.11074 44.9999 0.765625 44.9999C0.459375 44.9999 0.191406 44.8271 0.0669922 44.5392C-0.0574219 44.2512 0 43.9249 0.210547 43.7041C0.258398 43.6562 4.25879 39.3466 5.45508 34.5091C2.04805 31.0825 0 26.7249 0 21.9642C0 10.9974 10.8456 2.09965 24.2738 2.00073Z",
    fill: "#203972"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M43.5491 12L50.372 5.17704C51.2093 4.33977 51.2093 2.98227 50.372 2.14432L48.8557 0.627955C48.0184 -0.209318 46.6609 -0.209318 45.823 0.627955L39 7.45091L32.177 0.627955C31.3398 -0.209318 29.9823 -0.209318 29.1443 0.627955L27.628 2.14432C26.7907 2.98159 26.7907 4.33909 27.628 5.17704L34.4509 12L27.628 18.823C26.7907 19.6602 26.7907 21.0177 27.628 21.8557L29.1443 23.372C29.9816 24.2093 31.3398 24.2093 32.177 23.372L39 16.5491L45.823 23.372C46.6602 24.2093 48.0184 24.2093 48.8557 23.372L50.372 21.8557C51.2093 21.0184 51.2093 19.6609 50.372 18.823L43.5491 12Z",
    fill: "#203972"
  })
], -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M43.5491 12L50.372 5.17704C51.2093 4.33977 51.2093 2.98227 50.372 2.14432L48.8557 0.627955C48.0184 -0.209318 46.6609 -0.209318 45.823 0.627955L39 7.45091L32.177 0.627955C31.3398 -0.209318 29.9823 -0.209318 29.1443 0.627955L27.628 2.14432C26.7907 2.98159 26.7907 4.33909 27.628 5.17704L34.4509 12L27.628 18.823C26.7907 19.6602 26.7907 21.0177 27.628 21.8557L29.1443 23.372C29.9816 24.2093 31.3398 24.2093 32.177 23.372L39 16.5491L45.823 23.372C46.6602 24.2093 48.0184 24.2093 48.8557 23.372L50.372 21.8557C51.2093 21.0184 51.2093 19.6609 50.372 18.823L43.5491 12Z",
  fill: "#203972"
}, null, -1))
const _hoisted_202 = [
  _hoisted_200,
  _hoisted_201
]
const _hoisted_203 = {
  class: "d-flex flex-column w-100 ps-6 pe-6 pt-3 pb-3 justify-content-center",
  style: {"margin":"0pc"}
}
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titulo mb-1" }, "Ofertas recusadas", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "1.375rem",
  height: "0.8125rem",
  viewBox: "0 0 22 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.51 12.6268L1.02062 3.13733C0.562952 2.67966 0.562952 1.93767 1.02062 1.48005L2.1274 0.373268C2.58429 -0.0836171 3.32477 -0.0844964 3.78273 0.371314L11.3387 7.89187L18.8946 0.371314C19.3526 -0.0844964 20.093 -0.0836171 20.5499 0.373268L21.6567 1.48005C22.1144 1.93772 22.1144 2.67971 21.6567 3.13733L12.1673 12.6268C11.7097 13.0844 10.9677 13.0844 10.51 12.6268Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_206 = [
  _hoisted_204,
  _hoisted_205
]
const _hoisted_207 = {
  key: 1,
  class: "card d-flex flex-row mb-6"
}
const _hoisted_208 = {
  class: "d-flex align-items-center p-6",
  style: {"background":"#f9f9f9","border-radius":"15px 0px 0px 15px","min-width":"117px"}
}
const _hoisted_209 = {
  style: {"margin":"auto","margin-bottom":"4rem"},
  width: "40",
  height: "2.8125rem",
  viewBox: "0 0 51 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.5" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.2738 2.00073C23.663 3.79755 24.0743 5.86473 25.5058 7.2974L30.2083 11.9999L25.5066 16.7015C23.4973 18.7109 23.4986 21.9672 25.5058 23.976L27.023 25.4933C29.0318 27.5021 32.2895 27.5021 34.2984 25.4933L39 20.7916L43.7016 25.4933C44.9359 26.7275 46.6415 27.2034 48.2392 26.921C45.5347 35.5504 35.9327 41.9285 24.5 41.9285C20.825 41.9285 17.351 41.247 14.2215 40.0664C11.8672 41.9477 7.11074 44.9999 0.765625 44.9999C0.459375 44.9999 0.191406 44.8271 0.0669922 44.5392C-0.0574219 44.2512 0 43.9249 0.210547 43.7041C0.258398 43.6562 4.25879 39.3466 5.45508 34.5091C2.04805 31.0825 0 26.7249 0 21.9642C0 10.9974 10.8456 2.09965 24.2738 2.00073Z",
    fill: "#203972"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M43.5491 12L50.372 5.17704C51.2093 4.33977 51.2093 2.98227 50.372 2.14432L48.8557 0.627955C48.0184 -0.209318 46.6609 -0.209318 45.823 0.627955L39 7.45091L32.177 0.627955C31.3398 -0.209318 29.9823 -0.209318 29.1443 0.627955L27.628 2.14432C26.7907 2.98159 26.7907 4.33909 27.628 5.17704L34.4509 12L27.628 18.823C26.7907 19.6602 26.7907 21.0177 27.628 21.8557L29.1443 23.372C29.9816 24.2093 31.3398 24.2093 32.177 23.372L39 16.5491L45.823 23.372C46.6602 24.2093 48.0184 24.2093 48.8557 23.372L50.372 21.8557C51.2093 21.0184 51.2093 19.6609 50.372 18.823L43.5491 12Z",
    fill: "#203972"
  })
], -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M43.5491 12L50.372 5.17704C51.2093 4.33977 51.2093 2.98227 50.372 2.14432L48.8557 0.627955C48.0184 -0.209318 46.6609 -0.209318 45.823 0.627955L39 7.45091L32.177 0.627955C31.3398 -0.209318 29.9823 -0.209318 29.1443 0.627955L27.628 2.14432C26.7907 2.98159 26.7907 4.33909 27.628 5.17704L34.4509 12L27.628 18.823C26.7907 19.6602 26.7907 21.0177 27.628 21.8557L29.1443 23.372C29.9816 24.2093 31.3398 24.2093 32.177 23.372L39 16.5491L45.823 23.372C46.6602 24.2093 48.0184 24.2093 48.8557 23.372L50.372 21.8557C51.2093 21.0184 51.2093 19.6609 50.372 18.823L43.5491 12Z",
  fill: "#203972"
}, null, -1))
const _hoisted_212 = [
  _hoisted_210,
  _hoisted_211
]
const _hoisted_213 = {
  class: "d-flex flex-column w-100 ps-6 pe-6 pt-3 pb-3 mt-5 justify-content-center",
  style: {"margin":"0pc"}
}
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titulo" }, "Ofertas recusadas", -1))
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "1.375rem",
  height: "0.875rem",
  viewBox: "0 0 22 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1673 0.873216L21.6568 10.3627C22.1144 10.8203 22.1144 11.5623 21.6568 12.0199L20.55 13.1267C20.0931 13.5836 19.3526 13.5845 18.8946 13.1287L11.3387 5.60813L3.78278 13.1287C3.32482 13.5845 2.58434 13.5836 2.12745 13.1267L1.02067 12.0199C0.563002 11.5623 0.563002 10.8203 1.02067 10.3627L10.51 0.873216C10.9677 0.415599 11.7097 0.415599 12.1673 0.873216Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_216 = [
  _hoisted_214,
  _hoisted_215
]
const _hoisted_217 = { class: "d-flex flex-row justify-content-between mt-6 mb-1" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Produto específico não disponível", -1))
const _hoisted_219 = { class: "texto" }
const _hoisted_220 = { class: "d-flex flex-row justify-content-between mb-1" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Valor acima do esperado", -1))
const _hoisted_222 = { class: "texto" }
const _hoisted_223 = {
  key: 1,
  class: "card p-4 d-flex flex-row mb-5"
}
const _hoisted_224 = { class: "row lojas_erps" }
const _hoisted_225 = { class: "col-lg-6 col-md-6 col-sm-6 mb-6" }
const _hoisted_226 = {
  key: 0,
  class: "card d-flex flex-column mb-4 h-100",
  style: {"padding":"2rem"}
}
const _hoisted_227 = { class: "d-flex flex-row justify-content-between gap-3" }
const _hoisted_228 = { class: "d-flex flex-row gap-2 align-items-start" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "titulo",
  style: {"margin-top":"3px"}
}, "Total de lojas:", -1))
const _hoisted_230 = { class: "fw-bolder fs-2" }
const _hoisted_231 = {
  key: 1,
  style: {"color":"#dc3545"},
  class: "spinner-border m-auto",
  role: "status"
}
const _hoisted_232 = { class: "ps-0 d-flex flex-column total-lojas-container" }
const _hoisted_233 = { class: "d-flex justify-content-between fs-4 mt-5" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Integradas", -1))
const _hoisted_235 = { class: "fw-bolder fs-2" }
const _hoisted_236 = { class: "d-flex justify-content-between fs-4" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Não integradas", -1))
const _hoisted_238 = { class: "text-danger fw-bolder fs-2" }
const _hoisted_239 = { class: "demo-progress" }
const _hoisted_240 = {
  key: 1,
  class: "card p-4 h-100"
}
const _hoisted_241 = { class: "col-lg-6 col-md-6 col-sm-6 mb-6" }
const _hoisted_242 = {
  key: 0,
  class: "card d-flex flex-column mb-4 h-100",
  style: {"padding":"2rem"}
}
const _hoisted_243 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex w-100 justify-content-between\" data-v-40a1a965><span class=\"titulo\" data-v-40a1a965>Automações integradas</span></div><ul class=\"col-12 d-flex flex-row my-5 ps-0 align-items-center\" data-v-40a1a965><li class=\"col-5 texto bold\" style=\"color:#b5b5c3;\" data-v-40a1a965>NOME</li><li class=\"col-3 texto text-end bold\" style=\"color:#b5b5c3;\" data-v-40a1a965>Dias p/ envio de produtos</li><li class=\"col-2 texto text-end bold\" style=\"color:#b5b5c3;\" data-v-40a1a965>QTD</li><li class=\"col-2 texto text-end bold\" style=\"color:#b5b5c3;\" data-v-40a1a965>%</li></ul>", 2)
const _hoisted_245 = { class: "col-12 d-flex flex-column ps-0" }
const _hoisted_246 = { class: "d-flex align-items-center flex-row col-5" }
const _hoisted_247 = {
  class: "p-3 me-3",
  style: {"background":"#f3f6f9","border-radius":"6px"}
}
const _hoisted_248 = {
  key: 0,
  width: "25",
  height: "23",
  viewBox: "0 0 25 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9583 2.77778H19.4444V1.04167C19.4444 0.46441 18.98 0 18.4028 0H6.59722C6.01997 0 5.55556 0.46441 5.55556 1.04167V2.77778H1.04167C0.46441 2.77778 0 3.24219 0 3.81944V6.25C0 7.79948 0.976562 9.39236 2.68663 10.6207C4.05382 11.6059 5.71615 12.2309 7.46094 12.4306C8.82378 14.6918 10.4167 15.625 10.4167 15.625V18.75H8.33333C6.80122 18.75 5.55556 19.6484 5.55556 21.1806V21.7014C5.55556 21.9878 5.78993 22.2222 6.07639 22.2222H18.9236C19.2101 22.2222 19.4444 21.9878 19.4444 21.7014V21.1806C19.4444 19.6484 18.1988 18.75 16.6667 18.75H14.5833V15.625C14.5833 15.625 16.1762 14.6918 17.5391 12.4306C19.2882 12.2309 20.9505 11.6059 22.3134 10.6207C24.0191 9.39236 25 7.79948 25 6.25V3.81944C25 3.24219 24.5356 2.77778 23.9583 2.77778ZM4.3099 8.36806C3.25087 7.60417 2.77778 6.75347 2.77778 6.25V5.55556H5.56424C5.60764 6.97049 5.81597 8.21181 6.11979 9.29687C5.46441 9.07118 4.85243 8.75868 4.3099 8.36806ZM22.2222 6.25C22.2222 6.94878 21.454 7.81684 20.6901 8.36806C20.1476 8.75868 19.5312 9.07118 18.8759 9.29687C19.1797 8.21181 19.388 6.97049 19.4314 5.55556H22.2222V6.25Z",
  fill: "#FFA800"
}, null, -1))
const _hoisted_250 = [
  _hoisted_249
]
const _hoisted_251 = {
  key: 1,
  width: "25",
  height: "23",
  viewBox: "0 0 25 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9583 2.99995H19.4444V1.26383C19.4444 0.686578 18.98 0.222168 18.4028 0.222168H6.59722C6.01997 0.222168 5.55556 0.686578 5.55556 1.26383V2.99995H1.04167C0.46441 2.99995 0 3.46436 0 4.04161V6.47217C0 8.02165 0.976562 9.61453 2.68663 10.8428C4.05382 11.8281 5.71615 12.4531 7.46094 12.6527C8.82378 14.914 10.4167 15.8472 10.4167 15.8472V18.9722H8.33333C6.80122 18.9722 5.55556 19.8706 5.55556 21.4027V21.9236C5.55556 22.21 5.78993 22.4444 6.07639 22.4444H18.9236C19.2101 22.4444 19.4444 22.21 19.4444 21.9236V21.4027C19.4444 19.8706 18.1988 18.9722 16.6667 18.9722H14.5833V15.8472C14.5833 15.8472 16.1762 14.914 17.5391 12.6527C19.2882 12.4531 20.9505 11.8281 22.3134 10.8428C24.0191 9.61453 25 8.02165 25 6.47217V4.04161C25 3.46436 24.5356 2.99995 23.9583 2.99995ZM4.3099 8.59022C3.25087 7.82633 2.77778 6.97564 2.77778 6.47217V5.77772H5.56424C5.60764 7.19265 5.81597 8.43397 6.11979 9.51904C5.46441 9.29335 4.85243 8.98085 4.3099 8.59022ZM22.2222 6.47217C22.2222 7.17095 21.454 8.03901 20.6901 8.59022C20.1476 8.98085 19.5312 9.29335 18.8759 9.51904C19.1797 8.43397 19.388 7.19265 19.4314 5.77772H22.2222V6.47217Z",
  fill: "#B5B5C3"
}, null, -1))
const _hoisted_253 = [
  _hoisted_252
]
const _hoisted_254 = {
  key: 2,
  width: "25",
  height: "23",
  viewBox: "0 0 25 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M23.9583 3.22224H19.4444V1.48612C19.4444 0.908868 18.98 0.444458 18.4028 0.444458H6.59722C6.01997 0.444458 5.55556 0.908868 5.55556 1.48612V3.22224H1.04167C0.46441 3.22224 0 3.68665 0 4.2639V6.69446C0 8.24394 0.976562 9.83682 2.68663 11.0651C4.05382 12.0504 5.71615 12.6754 7.46094 12.875C8.82378 15.1363 10.4167 16.0695 10.4167 16.0695V19.1945H8.33333C6.80122 19.1945 5.55556 20.0929 5.55556 21.625V22.1458C5.55556 22.4323 5.78993 22.6667 6.07639 22.6667H18.9236C19.2101 22.6667 19.4444 22.4323 19.4444 22.1458V21.625C19.4444 20.0929 18.1988 19.1945 16.6667 19.1945H14.5833V16.0695C14.5833 16.0695 16.1762 15.1363 17.5391 12.875C19.2882 12.6754 20.9505 12.0504 22.3134 11.0651C24.0191 9.83682 25 8.24394 25 6.69446V4.2639C25 3.68665 24.5356 3.22224 23.9583 3.22224ZM4.3099 8.81251C3.25087 8.04862 2.77778 7.19793 2.77778 6.69446V6.00001H5.56424C5.60764 7.41494 5.81597 8.65626 6.11979 9.74133C5.46441 9.51564 4.85243 9.20314 4.3099 8.81251ZM22.2222 6.69446C22.2222 7.39324 21.454 8.2613 20.6901 8.81251C20.1476 9.20314 19.5312 9.51564 18.8759 9.74133C19.1797 8.65626 19.388 7.41494 19.4314 6.00001H22.2222V6.69446Z",
  fill: "#8F5E00"
}, null, -1))
const _hoisted_256 = [
  _hoisted_255
]
const _hoisted_257 = {
  key: 3,
  width: "25",
  height: "23",
  viewBox: "0 0 25 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9.96211 10.8874C10.2063 11.1315 10.602 11.1315 10.8461 10.8874L11.2879 10.4456C11.532 10.2015 11.532 9.80575 11.2879 9.56161L9.89258 8.16669L11.2875 6.77137C11.5316 6.52723 11.5316 6.13153 11.2875 5.88739L10.8457 5.44559C10.6016 5.20145 10.2059 5.20145 9.96172 5.44559L7.68281 7.7245C7.43867 7.96864 7.43867 8.36434 7.68281 8.60848L9.96211 10.8874ZM13.7125 10.446L14.1543 10.8878C14.3984 11.1319 14.7941 11.1319 15.0383 10.8878L17.3172 8.60887C17.5613 8.36473 17.5613 7.96903 17.3172 7.72489L15.0383 5.44598C14.7941 5.20184 14.3984 5.20184 14.1543 5.44598L13.7125 5.88778C13.4684 6.13192 13.4684 6.52762 13.7125 6.77176L15.1074 8.16669L13.7125 9.562C13.4684 9.80614 13.4684 10.2018 13.7125 10.446ZM24.375 16.9167H14.9039C14.875 17.6905 14.3293 18.1667 13.625 18.1667H11.25C10.5199 18.1667 9.96016 17.4843 9.96992 16.9167H0.625C0.28125 16.9167 0 17.1979 0 17.5417V18.1667C0 19.5417 1.125 20.6667 2.5 20.6667H22.5C23.875 20.6667 25 19.5417 25 18.1667V17.5417C25 17.1979 24.7188 16.9167 24.375 16.9167ZM22.5 2.54169C22.5 1.51044 21.6562 0.666687 20.625 0.666687H4.375C3.34375 0.666687 2.5 1.51044 2.5 2.54169V15.6667H22.5V2.54169ZM20 13.1667H5V3.16669H20V13.1667Z",
  fill: "#203972"
}, null, -1))
const _hoisted_259 = [
  _hoisted_258
]
const _hoisted_260 = { class: "texto bold" }
const _hoisted_261 = { class: "col-3 d-flex justify-content-end texto" }
const _hoisted_262 = { class: "col-2 d-flex justify-content-end texto" }
const _hoisted_263 = { class: "col-2 d-flex justify-content-end texto" }
const _hoisted_264 = {
  key: 1,
  class: "card p-4 h-100"
}
const _hoisted_265 = {
  key: 0,
  class: "row graficoHistoricoOs"
}
const _hoisted_266 = { class: "col-12" }
const _hoisted_267 = { class: "card p-8" }
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "titulo" }, "Historico de OS")
], -1))
const _hoisted_269 = {
  key: 1,
  class: "card p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_CardAtendimentos = _resolveComponent("CardAtendimentos")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_ModalAtendimentos = _resolveComponent("ModalAtendimentos")!
  const _component_ModalAtendimentosDetalhados = _resolveComponent("ModalAtendimentosDetalhados")!
  const _component_ImplantacoesInfo = _resolveComponent("ImplantacoesInfo")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Title, null, {
          default: _withCtx(() => [
            _createTextVNode("Dashboard Indicar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              style: {"margin-left":"auto"},
              modelValue: _ctx.value2,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value2) = $event)),
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": "Mês inicial",
              "end-placeholder": "Mês final",
              format: "DD/MM/YYYY",
              "default-value": [new Date(), new Date()]
            }, null, 8, ["modelValue", "default-value"])
          ]),
          _: 1
        }, 8, ["locale"]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.baixaAtendimento())),
          disabled: _ctx.loadingDownloadAtendimento,
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, [
          (!_ctx.loadingDownloadAtendimento)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
          (!_ctx.loadingDownloadAtendimento)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Exportar"))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, "Baixando..."))
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.contentDashboard.total.qtd > 0)
                    ? (_openBlock(), _createBlock(_component_apexchart, {
                        key: 0,
                        type: "pie",
                        options: _ctx.chartOptionsAtendimentos,
                        series: _ctx.series,
                        class: "col-6 grafico-atendimentos"
                      }, null, 8, ["options", "series"]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17)),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.total.qtd.toLocaleString("pt-BR")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.baixaAtendimento())),
                          disabled: _ctx.loadingDownloadAtendimento,
                          class: "btn btn-light-danger d-flex d-block flex-row justify-content-center align-items-center p-3 gap-4",
                          style: {"height":"40px","width":"50px"}
                        }, [
                          (!_ctx.loadingDownloadAtendimento)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_26))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                        ], 8, _hoisted_23),
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalTodosAtendimentos('ModalAtendimentosDetalhados'))),
                          disabled: _ctx.loaderTodosAtendimentos,
                          class: "btn btn-light-danger d-flex d-inline-block flex-row justify-content-center align-items-center p-3 gap-4",
                          style: {"height":"40px","width":"50px"}
                        }, [
                          (!_ctx.loaderTodosAtendimentos)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
                            : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                        ], 8, _hoisted_30)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.contentDashboard.buscaPlaca.qtd.toLocaleString("pt-BR")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.contentDashboard.manual.qtd.toLocaleString("pt-BR")), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 1
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_45, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.contentDashboard.valorOfertado.valor? _ctx.contentDashboard.valorOfertado.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }) : 0), 1)
                      ])
                    ]),
                    _hoisted_52
                  ]),
                  (_ctx.contentDashboard.total.qtd > 0)
                    ? (_openBlock(), _createBlock(_component_apexchart, {
                        key: 0,
                        class: "grafico-valor-ofertado",
                        type: "donut",
                        options: _ctx.chartOptionsOS,
                        series: _ctx.seriesOS
                      }, null, 8, ["options", "series"]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_53, _hoisted_55))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 1
                  })
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("section", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _hoisted_68,
                              _hoisted_69,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.atendimentosOs && _ctx.contentDashboard.novoTotalPagos.atendimentosOs !== 0 ? Number(_ctx.contentDashboard.novoTotalPagos.atendimentosOs).toLocaleString("pt-BR") : "0"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _hoisted_72,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.valorOs && _ctx.contentDashboard.novoTotalPagos.valorOs !== 0 ? _ctx.contentDashboard.novoTotalPagos.valorOs.toLocaleString("pt-BR", {style: "currency",currency: "BRL",}) : "R$ 0,00"), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _hoisted_78,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.atendimentosBazar && _ctx.contentDashboard.novoTotalPagos.atendimentosBazar !== 0 ? Number(_ctx.contentDashboard.novoTotalPagos.atendimentosBazar).toLocaleString("pt-BR") : "0"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _hoisted_80,
                              _hoisted_81,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.valorBazar && _ctx.contentDashboard.novoTotalPagos.valorBazar !== 0 ? _ctx.contentDashboard.novoTotalPagos.valorBazar.toLocaleString("pt-BR", {style: "currency",currency: "BRL",}) : "R$ 0,00"), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("ul", _hoisted_82, [
                      _createElementVNode("li", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.atendimentos && _ctx.contentDashboard.novoTotalPagos.atendimentos !== 0 ? _ctx.contentDashboard.novoTotalPagos.atendimentos.toLocaleString("pt-BR") : "0"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.consumidorPreenchido && _ctx.contentDashboard.novoTotalPagos.consumidorPreenchido !== 0 ? _ctx.contentDashboard.novoTotalPagos.consumidorPreenchido.toLocaleString("pt-BR") : "0"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_89, [
                        _hoisted_90,
                        _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.valorFaturado && _ctx.contentDashboard.novoTotalPagos.valorFaturado !== 0 ? _ctx.contentDashboard.novoTotalPagos.valorFaturado.toLocaleString("pt-BR", {style: "currency",currency: "BRL",}) : "R$ 0,00"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.cestaDeProdutos && _ctx.contentDashboard.novoTotalPagos.cestaDeProdutos !== 0 ? _ctx.contentDashboard.novoTotalPagos.cestaDeProdutos.toLocaleString("pt-BR",{minimumFractionDigits: 2, maximumFractionDigits: 2}) : "0"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.contentDashboard.novoTotalPagos.ticketMedio && _ctx.contentDashboard.novoTotalPagos.ticketMedio !== 0 ? _ctx.contentDashboard.novoTotalPagos.ticketMedio.toLocaleString("pt-BR", {style: "currency",currency: "BRL",}) : "R$ 0,00"), 1)
                      ]),
                      _hoisted_98
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _createElementVNode("span", null, [
                          _createElementVNode("h4", _hoisted_106, _toDisplayString(_ctx.contentDashboard.transmitido.qtd !== 0
                          ? ((_ctx.contentDashboard.transmitido.qtd / _ctx.seriesOS.reduce((total, valor) => total + valor, 0)) * 100).toFixed(1) + "%"
                          : "0%"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("section", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _hoisted_112,
                              _hoisted_113,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.transmitido.os && _ctx.contentDashboard.transmitido.os.toLocaleString("pt-BR")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _hoisted_115,
                              _hoisted_116,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.transmitido.valorOs && _ctx.contentDashboard.transmitido.valorOs.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",})), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_117, [
                          _hoisted_118,
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _hoisted_121,
                              _hoisted_122,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.transmitido.bazar && _ctx.contentDashboard.transmitido.bazar.toLocaleString("pt-BR")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _hoisted_124,
                              _hoisted_125,
                              _createElementVNode("span", null, _toDisplayString(_ctx.contentDashboard.transmitido.valorBazar && 
                              _ctx.contentDashboard.transmitido.valorBazar.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",})), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("ul", _hoisted_126, [
                      _createElementVNode("li", _hoisted_127, [
                        _hoisted_128,
                        _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.contentDashboard.transmitido.qtd.toLocaleString("pt-BR")), 1)
                      ]),
                      _createElementVNode("li", _hoisted_130, [
                        _hoisted_131,
                        _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.contentDashboard.consumidorPreenchido && _ctx.contentDashboard.consumidorPreenchido !== 0 ? _ctx.contentDashboard.consumidorPreenchido.toLocaleString("pt-BR") : "0"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_133, [
                        _hoisted_134,
                        _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.contentDashboard.transmitido.valor.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })), 1)
                      ]),
                      _createElementVNode("li", _hoisted_136, [
                        _hoisted_137,
                        _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.contentDashboard.produtos.qtd !== 0 ? (_ctx.contentDashboard.produtos.qtd / _ctx.contentDashboard.transmitido.qtd).toFixed(1) : "0"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_139, [
                        _hoisted_140,
                        _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.contentDashboard.transmitido.valor !== 0
                        ? (_ctx.contentDashboard.transmitido.valor / _ctx.contentDashboard.transmitido.qtd).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : "R$ 0,00"), 1)
                      ]),
                      _createElementVNode("li", _hoisted_142, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModalAtendimentosFinalizados('ModalAtendimentosDetalhados'))),
                          disabled: _ctx.loaderFinalizados,
                          class: "btn btn-sm btn-light-danger d-flex flex-row align-items-center gap-2 justify-content-center p-0 col-6"
                        }, [
                          (!_ctx.loaderFinalizados)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_144, _hoisted_146))
                            : (_openBlock(), _createElementBlock("div", _hoisted_147, _hoisted_149)),
                          _hoisted_150
                        ], 8, _hoisted_143),
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModalValorAtendimentos('ModalAtendimentosDetalhados'))),
                          disabled: _ctx.loaderFaturados,
                          class: "btn btn-sm btn-light-danger d-flex flex-row align-items-center gap-2 justify-content-center p-0 col-6"
                        }, [
                          (!_ctx.loaderFaturados)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_152, _hoisted_154))
                            : (_openBlock(), _createElementBlock("div", _hoisted_155, _hoisted_157)),
                          _hoisted_158
                        ], 8, _hoisted_151)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_159, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 1
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_160, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                  _hoisted_162,
                  _createElementVNode("ul", _hoisted_163, [
                    _createElementVNode("li", _hoisted_164, [
                      _hoisted_165,
                      _createElementVNode("span", null, [
                        _createElementVNode("h4", _hoisted_166, _toDisplayString(_ctx.contentDashboard.orcamentos.qtd !== 0
                          ? ((_ctx.contentDashboard.orcamentos.qtd / _ctx.seriesOS.reduce((total, valor) => total + valor, 0)) * 100).toFixed(1)
                          : "0") + "% ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("li", _hoisted_168, [
                        _hoisted_169,
                        _createElementVNode("span", _hoisted_170, _toDisplayString(_ctx.contentDashboard.orcamentos.qtd.toLocaleString("pt-BR")), 1)
                      ]),
                      _createElementVNode("li", _hoisted_171, [
                        _hoisted_172,
                        _createElementVNode("span", _hoisted_173, _toDisplayString(_ctx.contentDashboard.orcamentos.valor.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })), 1)
                      ]),
                      _createElementVNode("li", _hoisted_174, [
                        _hoisted_175,
                        _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.contentDashboard.orcamentos.valor !== 0
                        ? (_ctx.contentDashboard.orcamentos.valor / _ctx.contentDashboard.orcamentos.qtd).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : " R$ 0,00"), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_177, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 1
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_178, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                  _hoisted_180,
                  _createElementVNode("ul", _hoisted_181, [
                    _createElementVNode("li", _hoisted_182, [
                      _hoisted_183,
                      _createElementVNode("span", null, [
                        _createElementVNode("h4", _hoisted_184, _toDisplayString(_ctx.contentDashboard.aberto.qtd !== 0
                          ? ((_ctx.contentDashboard.aberto.qtd / _ctx.seriesOS.reduce((total, valor) => total + valor, 0)) * 100).toFixed(1)
                          : "0") + "% ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_185, [
                      _createElementVNode("li", _hoisted_186, [
                        _hoisted_187,
                        _createElementVNode("span", _hoisted_188, _toDisplayString(_ctx.contentDashboard.aberto.qtd.toLocaleString("pt-BR")), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_189, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 1
                  })
                ]))
          ])
        ]),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayDataCardsAtendimentos, (item, key) => {
                return (_openBlock(), _createBlock(_component_CardAtendimentos, {
                  data: item,
                  key: key
                }, {
                  default: _withCtx(() => [
                    (key < 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_191, _hoisted_193))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["data"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_194, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 1
              })
            ])),
        _createElementVNode("div", _hoisted_195, [
          _createElementVNode("div", _hoisted_196, [
            (!_ctx.declinedIndicarLoader)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!!_ctx.openDropdown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                        _createElementVNode("div", _hoisted_198, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_199, _hoisted_202))
                        ]),
                        _createElementVNode("ul", _hoisted_203, [
                          _createElementVNode("li", {
                            class: "d-flex flex-row justify-content-between align-items-center cursor-pointer",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeDrop && _ctx.changeDrop(...args)))
                          }, _hoisted_206)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_207, [
                        _createElementVNode("div", _hoisted_208, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_209, _hoisted_212))
                        ]),
                        _createElementVNode("ul", _hoisted_213, [
                          _createElementVNode("li", {
                            class: "d-flex flex-row justify-content-between align-items-center cursor-pointer",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeDrop && _ctx.changeDrop(...args)))
                          }, _hoisted_216),
                          _createElementVNode("li", _hoisted_217, [
                            _hoisted_218,
                            _createElementVNode("span", _hoisted_219, _toDisplayString(_ctx.declinedIndicar.produto), 1)
                          ]),
                          _createElementVNode("li", _hoisted_220, [
                            _hoisted_221,
                            _createElementVNode("span", _hoisted_222, _toDisplayString(_ctx.declinedIndicar.valor), 1)
                          ])
                        ])
                      ]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_223, [
                  _createVNode(_component_el_skeleton, {
                    class: "w-100",
                    animated: "",
                    rows: 0
                  }),
                  _createVNode(_component_el_skeleton, {
                    class: "w-100",
                    animated: "",
                    rows: 0
                  })
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_224, [
        _createElementVNode("div", _hoisted_225, [
          (!_ctx.updateChart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                _createElementVNode("div", _hoisted_227, [
                  _createElementVNode("div", _hoisted_228, [
                    _hoisted_229,
                    _createElementVNode("span", _hoisted_230, _toDisplayString(_ctx.totalLojas || ""), 1)
                  ]),
                  _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        style: {"width":"11rem"},
                        modelValue: _ctx.mesHistLoja,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mesHistLoja) = $event)),
                        type: "month",
                        placeholder: "Mês refêrencia",
                        format: "DD/MM/YYYY",
                        "default-value": [new Date()]
                      }, null, 8, ["modelValue", "default-value"])
                    ]),
                    _: 1
                  }, 8, ["locale"])
                ]),
                (!_ctx.updateChart)
                  ? (_openBlock(), _createBlock(_component_apexchart, {
                      key: 0,
                      type: "area",
                      height: "250",
                      options: _ctx.chartOptionsGrafico,
                      series: _ctx.seriesGrafico
                    }, null, 8, ["options", "series"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_231)),
                _createElementVNode("ul", _hoisted_232, [
                  _createElementVNode("li", _hoisted_233, [
                    _hoisted_234,
                    _createElementVNode("span", _hoisted_235, _toDisplayString(_ctx.lojasIntegradas), 1)
                  ]),
                  _createElementVNode("li", _hoisted_236, [
                    _hoisted_237,
                    _createElementVNode("span", _hoisted_238, _toDisplayString(_ctx.totalLojas - _ctx.lojasIntegradas), 1)
                  ]),
                  _createElementVNode("li", _hoisted_239, [
                    _createVNode(_component_el_progress, {
                      "text-inside": true,
                      color: "#3699FF",
                      "stroke-width": 26,
                      percentage: ((_ctx.lojasIntegradas / _ctx.totalLojas) * 100).toFixed(2)
                    }, null, 8, ["percentage"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_240, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  rows: 2
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_241, [
          (!_ctx.isLoadingStoresErps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                _hoisted_243,
                _createElementVNode("ul", _hoisted_245, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeInt.integracoes, (store, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      class: "d-flex flex-row mb-5 col align-items-center"
                    }, [
                      _createElementVNode("div", _hoisted_246, [
                        _createElementVNode("div", _hoisted_247, [
                          (key == 0)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_248, _hoisted_250))
                            : _createCommentVNode("", true),
                          (key == 1)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_251, _hoisted_253))
                            : _createCommentVNode("", true),
                          (key == 2)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_254, _hoisted_256))
                            : _createCommentVNode("", true),
                          (key > 2)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_257, _hoisted_259))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_260, _toDisplayString(store.nome.charAt(0).toUpperCase() + store.nome.slice(1)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_261, _toDisplayString(store.tempo !== null && store.tempo !== undefined ? store.tempo.toFixed(1) : '-'), 1),
                      _createElementVNode("span", _hoisted_262, _toDisplayString(store.lojas), 1),
                      _createElementVNode("span", _hoisted_263, _toDisplayString(((store.lojas / _ctx.storeInt.total) * 100).toFixed(0)) + "%", 1)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_264, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  rows: 2
                })
              ]))
        ])
      ]),
      (!_ctx.updateChartOS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
            _createElementVNode("div", _hoisted_266, [
              _createElementVNode("div", _hoisted_267, [
                _hoisted_268,
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "350",
                  options: _ctx.chartOptionsHistOS,
                  series: _ctx.seriesHistOS
                }, null, 8, ["options", "series"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_269, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 1
            })
          ]))
    ]),
    _createVNode(_component_ModalAtendimentos),
    _createVNode(_component_ModalAtendimentosDetalhados),
    _createVNode(_component_ImplantacoesInfo)
  ]))
}